var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',[_c('v-icon',{attrs:{"slot":"append","color":"red"},slot:"append"},[_vm._v("mdi-plus")]),_c('v-icon',{attrs:{"slot":"prepend","color":"green"},slot:"prepend"},[_vm._v("mdi-minus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }